import { render, staticRenderFns } from "./definir_quantidade_estudante.vue?vue&type=template&id=302b970a&"
import script from "./definir_quantidade_estudante.vue?vue&type=script&lang=js&"
export * from "./definir_quantidade_estudante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports